import axiosInstance from "../../utils/axiosCompany";

export const ListTransaction = async (values) => {
    return await axiosInstance().post("company/transaction/list-transaction", values);
}
export const ViewTransaction = async (values) => {
    return await axiosInstance().post("company/transaction/get-transaction", values);
}